var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import StepperMui from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector from '@mui/material/StepConnector';
import { StopIcon, LooseIcon, AnalyseIcon, NegociationIcon, ConclusionIcon, ClotureIcon, } from './Icons';
import { IconButton, Stack } from '@mui/material';
import { getColor, getColors } from './Classes';
import { Typography } from './Typography';
import { FONT_SIZE } from '../theme';
import { formatDate } from '../services/utils/utils';
var stepIcons = {
    'A': StopIcon,
    'P': LooseIcon,
    0: AnalyseIcon,
    1: NegociationIcon,
    2: ConclusionIcon,
    3: ClotureIcon,
};
export var Stepper = function (_a) {
    var steps = _a.steps, value = _a.value, disabled = _a.disabled, onClick = _a.onClick;
    var palette = getColors();
    var CustomStepIcon = function (props, _a) {
        var Id = _a.Id;
        var active = props.active, completed = props.completed;
        var color = ['A', 'P'].includes(Id) ? 'error' : active || completed ? 'success' : 'disabled';
        var Icon = stepIcons[Id];
        return (_jsx(IconButton, __assign({ disabled: disabled, sx: __assign({}, (color
                ? {
                    color: getColor(palette, color),
                    border: '2px solid ' + getColor(palette, color),
                }
                : {})), size: 'medium', onClick: function () { return onClick(Id, steps[steps.length - 1].Id === Id ? 'C' : null); } }, { children: Icon && _jsx(Icon, { color: color }) })));
    };
    var renderLabel = function (_a) {
        var Id = _a.Id, Libelle = _a.Libelle, Date = _a.Date;
        var color = ['A', 'P'].includes(Id) ? 'error' : Id === activeStep ? 'success' : 'neutre';
        return _jsxs(_Fragment, { children: [_jsx(Typography, __assign({ sx: { color: getColor(palette, color) }, className: Id === value ? 'bold' : '', variant: "body2" }, { children: Libelle })), Id <= activeStep && Date && (_jsx(Typography, __assign({ sx: { color: getColor(palette, color), fontSize: FONT_SIZE.SMALL } }, { children: formatDate(Date, false) })))] });
    };
    var activeStep = steps.map(function (_a) {
        var Id = _a.Id;
        return Id;
    }).indexOf(value);
    return (_jsx(StepperMui, __assign({ className: "w-full", alternativeLabel: true, activeStep: activeStep < 0 ? 0 : activeStep, connector: _jsx(StepConnector, {}) }, { children: steps.map(function (step) {
            var Id = step.Id;
            return (_jsx(Step, __assign({ disabled: disabled, completed: Id <= activeStep }, { children: _jsx(StepLabel, __assign({ StepIconComponent: function (e) { return CustomStepIcon(e, step); } }, { children: renderLabel(step) })) }), Id));
        }) })));
};
//# sourceMappingURL=Stepper.js.map